/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from "react";
import { assets } from "~/assets";
import { highlightText } from "~/utils/highlightText";

export function FaqItem({ title, answer, search }: { title: string; answer: string; search?: string }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(search ? true : false);
  }, [search]);

  const rotation = open ? "-rotate-180" : "";
  const maxHeight = open ? "max-h-full mt-3.5" : "";

  return (
    <div className="border bg-white p-4 transition-all print:break-inside-avoid">
      <div
        onClick={() => setOpen(!open)}
        className="flex cursor-pointer select-none items-center justify-between gap-x-3"
      >
        <h3 className="select-none">{highlightText({ content: title, highlight: search })}</h3>
        <div className={`transform select-none transition-transform ${rotation}`}>
          <img src={assets["./icons/Caret-down.svg"]!} alt="caret" />
        </div>
      </div>
      <div className={`max-h-0 overflow-hidden transition-all ${maxHeight} print:mt-3.5 print:max-h-full`}>
        <p className="whitespace-pre-line">
          {highlightText({
            content: answer?.replaceAll("<br/>", "") ?? "",
            highlight: search,
          })}
        </p>
      </div>
    </div>
  );
}
